$(function (readyEvent) {
    function createNavigateFunction(sliderRoot) {
        return function () {
            if ($(this).hasClass("active")) return;

            const step = $(this).data("step");
            let showElementCount = $(sliderRoot).data("showElementsSm");

            // check for screen size
            if (window.innerWidth >= 576) {
                showElementCount = $(sliderRoot).data("showElementsMd");
            }

            if (window.innerWidth >= 768) {
                showElementCount = $(sliderRoot).data("showElementsLg");
            }

            $(sliderRoot).data("step", step);

            $(sliderRoot)
                .children(".fe-event-list--carousel--inner")
                .css(
                    "margin-left",
                    `calc(${-step * 100}% / ${showElementCount})`
                );

            $(sliderRoot)
                .find(".fe-carousel-navigation--dot.active")
                .removeClass("active");
            $(this).addClass("active");
        };
    }

    $(".fe-event-list--carousel").each(function () {
        const itemCount = $(this).find(".fe-event").length;
        const currentStep = $(this).data("step");

        let showElementCount = $(this).data("showElementsSm");

        // check for screen size
        if (window.innerWidth >= 576) {
            showElementCount = $(this).data("showElementsMd");
        }

        if (window.innerWidth >= 768) {
            showElementCount = $(this).data("showElementsLg");
        }

        if (itemCount > showElementCount) {
            const navigationDots = [];
            for (let i = 0; i < itemCount - showElementCount + 1; i++) {
                navigationDots[i] = document.createElement("span");

                $(navigationDots[i]).addClass("fe-carousel-navigation--dot");
                if (currentStep === i) $(navigationDots[i]).addClass("active");

                $(navigationDots[i]).data("step", i);

                $(navigationDots[i]).on("click", createNavigateFunction(this));
            }

            const navigationContainer = document.createElement("div");
            $(navigationContainer).addClass("fe-carousel-navigation");
            $(navigationContainer).append(...navigationDots);

            $(this).append(navigationContainer);
        }
    });
});
